import React, { useState } from 'react';
import '../styles/addPerson.css';
import Dialogs from '../shared/Dialogs';
import { formatPhoneNumber, errorLogEnabled } from '../shared/Utils';
import Translate from '../shared/Translate';
import WsContainers from '../shared/WsContainers';
import { redirectToContact } from '../shared/customUiSdk';

const AddPerson = ({ phoneNumber, credentials, sdk, providedName }) => {

  const onClose = () => Dialogs.close(false);
  const onConfirm = (name) => {
    WsContainers.action({
      _class: 'com.optimsys.costra.optimcall.pipedrive.person.AddPersonToPipedrive',
      credentials: credentials,
      name: name,
      phoneNumber: phoneNumber,
    }).then((result) => {
      const personId = result?.data?.id
      redirectToContact(sdk, personId)
      onClose()
    }).catch((error) => {
      errorLogEnabled && console.error('Error during adding person:', error);
    });
  }

  const [name, setName] = useState(providedName || '');

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  return (
    <div className="dialog-overlay">
      <div className="dialog">
        <div className="dialog-title">Add Person</div>
        <div className="dialog-content">
          <div>
            {Translate.get('addPerson.dialog.title')}
          </div>
          <div className='dialog-phone-number'>{formatPhoneNumber(phoneNumber)}</div>
          <input
            type="text"
            placeholder={Translate.get('addPerson.dialog.name.placeholder')}
            value={name}
            onChange={handleNameChange}
            className="dialog-input"
          />
        </div>
        <div className="dialog-actions">
          <button onClick={onClose} className="dialog-button">
            {Translate.get('addPerson.dialog.cancel.button')}
          </button>
          <button
            onClick={() => onConfirm(name)}
            disabled={!name.trim()}
            className="dialog-button dialog-button-confirm"
          >
            {Translate.get('addPerson.dialog.confirm.button')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddPerson;
